exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".error-msg{color:red;font-size:12px;font-weight:700}.is-valid{border-color:green}.is-invalid{border-color:red;font-size:12px}.success-msg{color:green;font-size:12px;font-weight:700}.success-box{background-color:#90ee90}.error-box,.success-box{padding:15px;border-radius:5px}.error-box{background-color:#f08080}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/vue-loader/lib??vue-loader-options!./src/components/login/FormRegister.vue?vue&type=style&index=0&id=4873afb6&prod&lang=css&
// module id = 939
// module chunks = 0